module.exports = __webpack_public_path__ + "static/bryan-johnson-32adbafdee61fe35cefc25fa0686d6f2.jpg";